import React, { useEffect } from 'react'
import Header from '../../../headerone/Main'
import Bredcom from '../../../Bredcom/Main'
import CitizenFocusedDigitalServicesDetails from '../../subdepartmentdetails/CitizenFocusedDigitalServices'


function CitizenFocusedDigitalServices() {

  useEffect(() => {
    document.getElementById("title").innerHTML="Citizen-Focused Digital Services || Innovation and Technology";
  }, [])


  return (
    <>
        {/* Header is now rendered at app level in routes/index.js to prevent remounting on navigation */}

        <div className="page-wrapper">
        <Bredcom 
            subtitle="Innovation Technology"
            title="Citizen Focused Digital Services"
            subtitledown="Department of Innovation & Technology"
           />
            <CitizenFocusedDigitalServicesDetails/>
        </div>
    </>
  )
}

export default CitizenFocusedDigitalServices